<!-- src/components/VueMultiselect.vue -->

<template>
    <div class="multiselect relative block" :class="{ 'multiselect-open': isOpen }" v-on-clickaway="away" v-on:keyup="keysort" tabindex="0">
        <div class="multiselect-title block w-full sm:text-sm border border-gray-300 p-2 flex flex-row justify-between items-center" @click="toggleOpen()">
          <span>{{ title }}</span>
          <span class="caret">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
  <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
</svg>
          </span>
        </div>
        <ul class="multiselect-options absolute bg-white max-h-72 overflow-y-scroll w-full z-20 rounded-b-md shadow-lg border-gray-300 border border-t-0" v-if="isOpen" ref="options">
            <li is="multiselect-option"
                v-for="(option, index) in options"
                v-bind:key="_optionId(option)"
                :option="option"
                :class="['multiselect-index-'+index, 'px-4 py-2 text-sm hover:bg-cal-F4F2F2 cursor-pointer']"
                :selected="isSelected(option)"
                v-on:selected-option="selectedOption">{{ _optionLabel(option) }}</li>
        </ul>
    </div>
</template>

<script>

// https://github.com/VinceG/vue-click-away
import {mixin as clickaway} from 'vue-clickaway'

export default {

    mixins: [ clickaway ],
    components: {
        MultiselectOption: {
            props: ['option', 'label', 'selected'],
            template: '<li @click="$emit(\'selected-option\', option)" :class="{ \'bg-cal-81B920 hover:bg-cal-81B920 text-white\': selected }"><span><slot></slot></span></li>'
        }
    },

    props: {
        'options': null,
        'value': null,
        'optionId': null,
        'optionLabel': null,
        'multiselect': {
            default: true
        },
        'maxTitleLength': {
            default: 50
        }
    },

    data () {
        return {
            isOpen: false
        }
    },

    created () {

        //this.selected = this.value;
    },

    computed: {

        title () {

            if (this.value && !this.multiselect) {

                if (this.isString(this.value)) {
                    return this.truncate(this.value);
                }

                for (var i in this.options) {
                    if (this._optionId(this.options[i]) == this.value) {
                        return this.truncate(this._optionLabel(this.options[i]));
                    }
                }
            }

            if (this.value && this.value.length > 0) {
                var selectedShort = this.value.slice(0, 10);

                var children = this.options.filter(function(item) {
                    return selectedShort.indexOf(this._optionId(item)) > -1;
                }.bind(this));

                return this.truncate(children.map(function(item) {
                    return this._optionLabel(item);
                }.bind(this)).join(", "));
            }
            return "Select"
        }
    },

    methods: {

        toggleOpen () {
            this.isOpen = !this.isOpen;

            /// Scroll to selected element
            if (this.isOpen && !this.multiselect) {
                this.$nextTick(function() {
                  const selectedElement = this.$refs.options.getElementsByClassName("multiselect-highlighted")[0];
                  if (selectedElement) {
                    const middleOffset = this.$refs.options.clientHeight / 2;
                    this.$refs.options.scrollTop = selectedElement.offsetTop - middleOffset;
                  }
                });
            }
        },

        isSelected (option) {
            var key = this._optionId(option);

            if (!this.multiselect) {
                return this.value == key;
            }

            return this.value.indexOf(key) > -1;
        },

        _optionLabel (option) {
            if (this.isString(option)) {
                return option;
            }
            return option[this.optionLabel];
        },

        _optionId (option) {
            if (this.isString(option)) {
                return option;
            }
            return option[this.optionId];
        },

        selectedOption (option) {

            var key = this._optionId(option);
            var tempSelected = this.value;

            if (!this.multiselect) {
                this.isOpen = false;
                this.$emit('input', key);
                return;
            }

            if (this.isSelected(option)) {
                var index = tempSelected.indexOf(key);
                if (index > -1) {
                    tempSelected.splice(index, 1);
                }
            }
            else {
                tempSelected.push(key);
            }

            this.$emit('input', tempSelected);
        },

        away () {
            if (this.isOpen) {
                this.isOpen = false;
            }
        },

        isString (s) {
            return typeof s === 'string' || s instanceof String;
        },

        truncate (s) {
            if (s.length > this.maxTitleLength) {
                return s.substring(0, this.maxTitleLength-3) + "...";
            }
            return s;
        },

        indexOfLetter(letter) {

            for (var i = 0; i < this.options.length; i++) {
                var firstLetter = this._optionLabel(this.options[i])[0];
                if (firstLetter.toLowerCase() == letter.toLowerCase()) {
                    return i;
                }
            }
            return -1;
        },

        scrollToIndex(index) {
            this.$nextTick(function() {
                var selectedElement = this.$refs.options.getElementsByClassName("multiselect-index-"+index)[0];
                var middleOffset = this.$refs.options.clientHeight / 2;
                var topOffset = selectedElement.offsetTop;
                this.$refs.options.scrollTop = topOffset;
            });
        },

        keysort ($event) {

            var index = this.indexOfLetter(String.fromCharCode($event.keyCode));
            if (index > -1) {
                this.scrollToIndex(index);
            }
        }
    }
}
</script>
